import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/** Plugins, configs & utils */
import vuetify from '@/plugins/vuetify'
import DialogPlugin from './plugins/DialogPlugin'
import i18n from '@/plugins/i18n'
import vuetifyDialog from '@/configs/vuetifyDialog'
import ApiIntervalPollingPlugin from '@/plugins/ApiIntervalPollingPlugin.js'
import '@/plugins/validations'
import '@/plugins/directives'
import '@/configs/nprogress'
import '@/configs/debug'

/** 3rd Party Packages */
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VuePlyr from 'vue-plyr'
import VuetifyDialog from 'vuetify-dialog'

// Mixins
import locale from '@/mixins/global/locale'
import app from '@/mixins/global/app'
import user from '@/mixins/global/user'
import datetime from '@/mixins/global/datetime'
import StoreMixin from '@/mixins/global/StoreMixin'
import LetsMixin from '@/mixins/global/LetsMixin'
import BrowserBackProtectionMixin from '@/mixins/global/BrowserBackProtectionMixin'

/** Other */
import 'es6-promise/auto'

/** CSS */
import '../node_modules/@fortawesome/fontawesome-free/css/all.css'
import '../node_modules/vuetify-dialog/dist/vuetify-dialog.css'
import '@/assets/css/nprogress.css'
import '@/assets/css/main.css'
import '@/assets/css/lets.css'
import '../node_modules/vue-plyr/dist/vue-plyr.css'

import { register } from 'swiper/element/bundle'

import moment from 'moment'
import 'moment-timezone'
register()
const systemTimezone = import.meta.env.VITE_APP_API_SYSTEM_TIMEZONE
moment.tz.setDefault(systemTimezone)

// Plugins Registration
Vue.use(VuetifyDialog, vuetifyDialog)
Vue.use(DialogPlugin, { vuetify })
Vue.use(VuePlyr)
Vue.use(ApiIntervalPollingPlugin)

/** Configuration */
if (import.meta.env.VITE_API_SELF_DOMAIN_ENABLED === 'true'){
  let port = '/'
  if (import.meta.env.VITE_API_PORT !== undefined && import.meta.env.VITE_API_PORT !== ''){
    port = `:${import.meta.env.VITE_API_PORT}/`
  }
  const domain = '//' + window.location.hostname + port
  Vue.prototype.$API_URL = domain
  window.API_URL = domain
} else {
  Vue.prototype.$API_URL = import.meta.env.VITE_API_URL
  window.API_URL = import.meta.env.VITE_API_URL
}
Vue.config.productionTip = false
Vue.config.performance = true

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

// GLobal Mixins Registrations
Vue.mixin(locale)
Vue.mixin(app)
Vue.mixin(user)
Vue.mixin(datetime)
Vue.mixin(StoreMixin)
Vue.mixin(LetsMixin)
Vue.mixin(BrowserBackProtectionMixin)



Vue.config.ignoredElements = [
  /^trix-/
]

window.vue = new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
})
